<template>
  <span>{{msg}}</span>
</template>

<script>
let idxCounterMsgs = 0
export default {
  name: "BannerTextColor",
  props: {
    msgs: {
      type: Array,
      required: true
    },
    rate: {
      type: Number,
      default: 2000
    }
  },
  data: function() {
    return {
      msg: "",
      idIntervalCycle: undefined
    };
  },
  mounted() {
    this.msg = this.msgs.length > 0 ? this.msgs[0] : ""
    this.idIntervalCycle = setInterval(() => {
        idxCounterMsgs++
        if(idxCounterMsgs >= this.msgs.length){
          idxCounterMsgs = 0
        }
        this.msg = this.msgs[idxCounterMsgs];
    }, this.rate);
  },
  destroyed() {
    if(this.idIntervalCycle){
      clearInterval(this.idIntervalCycle)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
